import * as React from 'react';
import isNil from 'lodash/isNil';

import CampaignEntityAvatar from 'components/entity/entity-avatar/CampaignEntityAvatar';

import CcmCampaignDetailsOverviewCampaign from './campaign/CcmCampaignDetailsOverviewCampaign';
import CcmCampaignDetailsOverviewBudget from './budget/CcmCampaignDetailsOverviewBudget';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDate } from 'utils/date';

import './ccm-campaign-details-overview.scss';

applyTranslations(require('./ccm-campaign-details-overview.i18n.json'));

import type { Campaign } from 'types';

type Props = {
  campaign: Campaign
};

const MSG_KEY = 'ccm_campaign_details_overview';

const CcmCampaignDetailsOverview: React.FC<Props> = ({
  campaign
}): JSX.Element => (
  <div className="ccm-campaign-details-overview">
    <div className="ccm-campaign-details-overview__image">
      <CampaignEntityAvatar
        disabled
        form="square"
        campaign={campaign}
        size="customSize"
        applyCustomElementSize={false}
        customSize={{
          width: 222,
          height: 336
        }}
      />
    </div>
    <div className="ccm-campaign-details-overview__info">
      <CcmCampaignDetailsOverviewCampaign
        campaign={campaign}
      />
      <CcmCampaignDetailsOverviewBudget
        campaign={campaign}
      />
      {
        !isNil(campaign.dataLastUpdated) && (
          <div className="ccm-campaign-details-overview__data-updated">
            {__t(`${MSG_KEY}.data_last_updated`)}: {getDisplayDate(campaign.dataLastUpdated)}
          </div>
        )
      }
    </div>
  </div>
);

export default CcmCampaignDetailsOverview;
